export default {"src":"/cbr/_next/static/media/lock-small.1bc8fa9d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};